import { injectable } from 'inversify';

import { QueryService } from '@vk-hr-tek/core/query';

import { WidgetLayout } from '../types';

@injectable()
export class DashboardMapper {
  constructor(private readonly query: QueryService) {}

  processLayout(widgets: WidgetLayout[], ignore: string[] = []) {
    return widgets
      .filter(
        (item) =>
          item.type !== 'quick_actions' &&
          (!!item.is_active || typeof item.is_active === 'undefined'),
      )
      .filter(
        (item) =>
          item.type !== 'partitions_employee' ||
          !window.REACT_APP_VKHRTEK_LK_DISABLED,
      )
      .filter((item) => !ignore.includes(item.type))
      .sort((a, b) => {
        if (a.type === 'posts_feed') return 1;
        return b.type === 'posts_feed' ? -1 : 0;
      })
      .map((widget) => ({
        id: widget.id,
        title: widget.custom_name,
        type: widget.type,
        i: widget.id,
        x: widget.type === 'posts_feed' ? 0 : widget.position.x,
        y: 0,
        w: widget.size,
        h: widget?.height || 1,
        hasFilter: !!widget?.settings?.has_filter,
      }));
  }
}
